<template>
    <div>
        <action-modal
                :headline="'Are you sure you want to delete all '+type+'?'"
                :button-label="'Delete All ' + capitalizedType"
                button-type="danger"
                :action-name="'Delete All'"
                :action-url="'/api/?entity='+type+'&action=deleteAll'"
                :action-params="{table: capitalizedType}"
                :redirect-url="'/inventory/' + type"
                :float-right="true"
                :custom-button-classes="['btn-md btn-link']"
                :input-confirmation="true"
                :input-confirmation-message="'This action cannot be undone.'">
        </action-modal>
    </div>
</template>

<script>
    import ActionModal from "../components/ActionModal";

    export default {
        name: 'delete-records',
        components: {ActionModal},
        computed: {
            capitalizedType: function() {
                return this.type.charAt(0).toUpperCase() + this.type.substring(1);
            }
        },
        props: {
            type: {
                type: String,
                required: true
            }
        }
    }
</script>
